import { THEME } from "common/src/helpers/constants";
import {
  StyledLight,
  StyledLightABC,
} from "../styledComponents/StyledTimeAndBulb";
import Time from "./Time";
import React from "react";

export function ThemeSwitcher({
  currentTheme,
  setTheme,
  player,
  skin,
  server,
}) {
  document.documentElement.setAttribute("data-theme", currentTheme);
  const nextTheme = currentTheme === "light" ? "dark" : "light";

  const switchTheme = () => {
    setTheme(nextTheme);
    document.documentElement.setAttribute("data-theme", nextTheme);
    localStorage.setItem(THEME, nextTheme);
  };

  return <></>;
}
